import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { SnackBarService } from 'services/snackbar.service';
import { AccountService } from 'services/account.service';
import { catchError, tap } from 'rxjs/operators';
import { DialogBaseComponent } from 'shared/dialogs/dialog-base/dialog-base.component';
import { of } from 'rxjs';
import { AppConfigService } from 'services/app-config.service';

@Component({
  selector: 'core-ui-eula-dialog',
  templateUrl: './eula-dialog.component.html',
  imports: [
    MatDialogModule,
    MatButton,
    MatAnchor,
    TranslateModule,
    MatCheckbox,
    DialogBaseComponent
  ]
})
export class EulaDialogComponent {
  protected eulaUrl: string;
  protected checkboxIsChecked = false;
  private dialogRef = inject(MatDialogRef<EulaDialogComponent>);
  private toast = inject(SnackBarService);
  private accountService = inject(AccountService);
  private appConfigService = inject(AppConfigService);

  constructor() {
    this.eulaUrl = this.appConfigService.appConfig.urls.eula;
  }

  public acceptEula(): void {
    this.accountService
      .acceptEula$()
      .pipe(
        tap(() => this.dialogRef.close(true)),
        catchError(() => {
          this.toast.pop('GENERIC.ERROR');
          return of(undefined);
        })
      )
      .subscribe();
  }

  public declineEula(): void {
    this.accountService.logout();
  }
}
